import { z } from "zod";
import { responseSchema } from "../http.js";
import { shippingAddressSchema } from "./shipping.js";
/**
 * ═══════════════════════════════════════════════════════════
 * Autocompletado de direcciones (Google Places)
 *
 * ── Por qué pasa por NUESTRO servidor ────────────────────────────────
 * Lo obvio sería cargar el SDK de Maps en el navegador con una clave
 * `VITE_…`. Eso mete la clave EN EL BUNDLE: cualquiera la copia del
 * JavaScript y la usa hasta agotar la cuota (y la factura es de Anahí).
 * La única defensa serían las restricciones por referente, que se
 * falsifican con una cabecera.
 *
 * Aquí la clave vive en el servidor (Secret Manager → Cloud Run) y el
 * frontend habla con `/api/places`. Se puede restringir por IP, se puede
 * rotar sin recompilar el frontend, y el navegador nunca la ve. De paso,
 * el mapeo de "lo que devuelve Google" a NUESTRA dirección ocurre una
 * vez, en el servidor, y se prueba.
 *
 * ── Sin clave, no es un error ────────────────────────────────────────
 * `status: "not_configured"` es un DATO, no un fallo: la pantalla cae al
 * formulario manual —que siempre está ahí— y nadie ve una pantalla rota.
 * Mismo trato que Stripe y Trasso.
 * ═══════════════════════════════════════════════════════════
 */
export const placeSuggestionSchema = z.object({
    /** El id de Google. Se manda de vuelta para pedir el detalle. */
    placeId: z.string().min(1),
    /** "Av. Siempre Viva 123" — lo que se pinta en negritas. */
    primary: z.string(),
    /** "Col. Centro, Ciudad de México, CDMX" — el resto. */
    secondary: z.string(),
});
export const placeSuggestionsResponseSchema = responseSchema(z.discriminatedUnion("status", [
    z.object({ status: z.literal("ready"), suggestions: z.array(placeSuggestionSchema) }),
    /** No hay clave de Google en el servidor: se escribe a mano. */
    z.object({ status: z.literal("not_configured") }),
]));
/**
 * El detalle ya traducido a NUESTRA dirección de envío. `null` cuando
 * Google conoce el sitio pero no da calle/CP —un municipio entero, por
 * ejemplo—: se devuelve lo que haya y la pantalla pide lo que falte.
 */
export const placeDetailsResponseSchema = responseSchema(z.object({
    address: shippingAddressSchema.partial(),
    /**
     * El país en ISO de dos letras ("MX", "US"). Va aparte de `address`
     * porque una dirección de envío no lo lleva —el pedido ya sabe su
     * moneda—, pero una SEDE sí: es un campo del formulario, y sin esto
     * quien busca una dirección de Estados Unidos tendría que acordarse
     * de bajar el selector a mano (Anahí, 29-ago).
     */
    country: z.string().length(2).optional(),
    /** Lo que Google llama la dirección completa, para enseñarla. */
    formatted: z.string().optional(),
}));
export const PLACE_QUERY_MIN = 3;
export const placeSuggestQuerySchema = z.object({
    q: z.string().trim().min(PLACE_QUERY_MIN).max(200),
    /**
     * Token de sesión de Places: agrupa las pulsaciones de teclado y el
     * detalle final en UNA búsqueda facturable en vez de N. Lo genera el
     * navegador y lo repite hasta elegir.
     */
    session: z.string().trim().min(8).max(80).optional(),
});
export const PLACES_ROUTES = {
    suggest: "/api/places/suggest",
    details: (placeId) => `/api/places/${encodeURIComponent(placeId)}`,
};
//# sourceMappingURL=places.js.map